angular.module('unica_location.location_services')

.factory('LocationListService', function($http, getBaseApiURL) {

	var locationListService = {};


	locationListService.list = function (limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/location/list',
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.locations;
			}

		});
	};


	locationListService.search = function (search)
	{
		var data = {
			search: search
		};

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/location/search',
			data: data
		}).then(function(result) {

			if ( result ) {
				return result.data.locations;
			}

		});

	};


	locationListService.searchNameOrAddress = function (search)
	{
		var data = {
			search: search
		};

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/location/search-name-address',
			data: data
		}).then(function(result) {

			if ( result ) {
				return result.data.locations;
			}

		});

	};



	locationListService.fullList = function ()
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/location/full-list',
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.locations;
			}

		});
	};


	locationListService.get = function (locationId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/location/detail/' + locationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.location;
			}

		});
	};


	return locationListService;

});